// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__44eTj {
  padding: 30px;
  max-width: 1400px;
  margin: 30px auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* Header Actions - Botões no topo */
.styles_header_actions__6qx1Y {
  display: flex;
  gap: 15px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.styles_back_btn__QvtNY {
  background-color: #6c757d !important;
  color: white !important;
  border: none !important;
  padding: 10px 20px !important;
  border-radius: 5px !important;
  cursor: pointer !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;
  text-transform: none !important;
  transition: background 0.3s !important;
}

.styles_back_btn__QvtNY:hover {
  background-color: #5a6268 !important;
}

.styles_btn_lancar_debito__3O41f {
  background-color: #d32f2f !important;
  color: white !important;
  border: none !important;
  padding: 12px 24px !important;
  border-radius: 5px !important;
  cursor: pointer !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;
  text-transform: none !important;
  transition: background 0.3s !important;
  box-shadow: 0 2px 8px rgba(211, 47, 47, 0.3) !important;
}

.styles_btn_lancar_debito__3O41f:hover {
  background-color: #c62828 !important;
  box-shadow: 0 4px 12px rgba(211, 47, 47, 0.4) !important;
}

/* Breadcrumb */
.styles_breadcrumb__zQzR\\+ {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.styles_breadcrumb_link__Ctn\\+4 {
  color: #1e4a7a;
  text-decoration: none;
}

.styles_breadcrumb_link__Ctn\\+4:hover {
  text-decoration: underline;
}

.styles_breadcrumb_separator__tKiel {
  margin: 0 5px;
}

.styles_breadcrumb_current__xjs\\+S {
  color: #333;
}

/* Client Header - Card Verde Grande */
.styles_client_header__EFrdj {
  background: linear-gradient(135deg, #1e4a7a 0%, #2a5298 100%);
  padding: 20px 25px;
  border-radius: 8px;
  color: white;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
}

.styles_client_header_left__nfIWv {
  flex: 1 1;
}

.styles_client_name__JvK1G {
  font-size: 24px !important;
  font-weight: 600 !important;
  margin-bottom: 10px !important;
  color: white !important;
}

.styles_client_info__dVMyf {
  display: flex;
  gap: 30px;
  font-size: 13px;
}

.styles_client_info_item__pUrlr {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.styles_client_info_label__oeJbK {
  opacity: 0.8;
  font-size: 11px !important;
  color: white !important;
}

.styles_client_info_value__EOsRZ {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: white !important;
}

/* Saldo Card */
.styles_saldo_card__VAypf {
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  padding: 15px 25px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  min-width: 250px;
}

.styles_saldo_label__RtVFZ {
  color: white !important;
  font-size: 12px !important;
  margin-bottom: 5px !important;
  opacity: 0.9;
}

.styles_saldo_value__ZG4IK {
  color: white !important;
  font-size: 28px !important;
  font-weight: 700 !important;
}

/* Grupo de Impostos */
.styles_grupo_impostos__hFq8K {
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 30px;
}

.styles_grupo_header__TWt-l {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #1e4a7a;
}

.styles_grupo_icon__iBOAe {
  font-size: 32px;
  display: flex;
  align-items: center;
}

.styles_grupo_title__lE1ax {
  flex: 1 1;
}

.styles_grupo_name__8bb7c {
  font-size: 22px !important;
  font-weight: 700 !important;
  color: #0d2847 !important;
}

.styles_grupo_saldo__lUiAJ {
  text-align: right;
}

.styles_grupo_saldo_label__bR2Uv {
  font-size: 12px !important;
  color: #666 !important;
  margin-bottom: 5px !important;
}

.styles_grupo_saldo_value__raHDN {
  font-size: 24px !important;
  font-weight: 700 !important;
  color: #2e7d32 !important;
}

/* Tabela de Transações */
.styles_table_container__BDBw3 {
  margin-top: 20px;
}

.styles_transactions_table__ux\\+EB {
  width: 100%;
  border-collapse: collapse;
}

.styles_transactions_table__ux\\+EB thead {
  background: #f8f9fa;
}

.styles_table_header_cell__J8hv6 {
  padding: 12px !important;
  text-align: left !important;
  font-weight: 600 !important;
  color: #0d2847 !important;
  border-bottom: 2px solid #e0e0e0 !important;
  font-size: 14px !important;
}

.styles_transactions_table__ux\\+EB th:nth-child(2),
.styles_transactions_table__ux\\+EB th:nth-child(3) {
  text-align: right !important;
  width: 180px;
}

.styles_table_row__0aZDv {
  border-bottom: 1px solid #f0f0f0 !important;
}

.styles_table_row__0aZDv:hover {
  background-color: #f9fbff !important;
}

.styles_transaction_name__rOHPT {
  font-weight: 500;
  color: #333;
  font-size: 13px;
}

.styles_transaction_date__MUzMW {
  font-size: 11px;
  color: #666;
  display: block;
  margin-top: 2px;
}

.styles_transaction_project__zjuyP {
  font-size: 11px;
  color: #1e4a7a;
  display: block;
  margin-top: 2px;
}

.styles_value_credito__QZo95 {
  color: #2e7d32;
  font-weight: 600;
  text-align: right;
}

.styles_value_debito__eMsW6 {
  color: #c62828;
  font-weight: 600;
  text-align: right;
}

.styles_value_empty__Y3HAt {
  color: #ddd;
  text-align: right;
}

.styles_table_footer__ZCp1r {
  background-color: #e3f2fd !important;
  font-weight: 700 !important;
}

.styles_table_footer_cell__Wt1Qa {
  padding: 15px !important;
  color: #0d2847 !important;
  border-top: 2px solid #1e4a7a !important;
}

.styles_table_footer_cell__Wt1Qa[align="right"] {
  white-space: nowrap;
  min-width: 180px;
}

.styles_total_credito__e0Yaz {
  color: #2e7d32;
  font-size: 16px;
  white-space: nowrap;
  display: inline-block;
}

.styles_total_debito__lTJVU {
  color: #c62828;
  font-size: 16px;
}

/* Responsividade */
@media (max-width: 768px) {
  .styles_container__44eTj {
    padding: 15px;
    margin: 15px;
  }

  .styles_client_header__EFrdj {
    flex-direction: column;
    align-items: flex-start;
  }

  .styles_saldo_card__VAypf {
    width: 100%;
  }

  .styles_client_info__dVMyf {
    flex-direction: column;
    gap: 15px;
  }

  .styles_header_actions__6qx1Y {
    flex-direction: column;
    align-items: stretch;
  }

  .styles_back_btn__QvtNY,
  .styles_btn_lancar_debito__3O41f {
    width: 100%;
  }

  .styles_grupo_header__TWt-l {
    flex-direction: column;
    align-items: flex-start;
  }

  .styles_grupo_saldo__lUiAJ {
    text-align: left;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContaCorrente/ContaCorrenteDetalhes/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,sCAAsC;EACtC,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA,eAAe;AACf;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF","sourcesContent":[".container {\n  padding: 30px;\n  max-width: 1400px;\n  margin: 30px auto;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Header Actions - Botões no topo */\n.header_actions {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.back_btn {\n  background-color: #6c757d !important;\n  color: white !important;\n  border: none !important;\n  padding: 10px 20px !important;\n  border-radius: 5px !important;\n  cursor: pointer !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  text-transform: none !important;\n  transition: background 0.3s !important;\n}\n\n.back_btn:hover {\n  background-color: #5a6268 !important;\n}\n\n.btn_lancar_debito {\n  background-color: #d32f2f !important;\n  color: white !important;\n  border: none !important;\n  padding: 12px 24px !important;\n  border-radius: 5px !important;\n  cursor: pointer !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  text-transform: none !important;\n  transition: background 0.3s !important;\n  box-shadow: 0 2px 8px rgba(211, 47, 47, 0.3) !important;\n}\n\n.btn_lancar_debito:hover {\n  background-color: #c62828 !important;\n  box-shadow: 0 4px 12px rgba(211, 47, 47, 0.4) !important;\n}\n\n/* Breadcrumb */\n.breadcrumb {\n  color: #666;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.breadcrumb_link {\n  color: #1e4a7a;\n  text-decoration: none;\n}\n\n.breadcrumb_link:hover {\n  text-decoration: underline;\n}\n\n.breadcrumb_separator {\n  margin: 0 5px;\n}\n\n.breadcrumb_current {\n  color: #333;\n}\n\n/* Client Header - Card Verde Grande */\n.client_header {\n  background: linear-gradient(135deg, #1e4a7a 0%, #2a5298 100%);\n  padding: 20px 25px;\n  border-radius: 8px;\n  color: white;\n  margin-bottom: 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 30px;\n}\n\n.client_header_left {\n  flex: 1;\n}\n\n.client_name {\n  font-size: 24px !important;\n  font-weight: 600 !important;\n  margin-bottom: 10px !important;\n  color: white !important;\n}\n\n.client_info {\n  display: flex;\n  gap: 30px;\n  font-size: 13px;\n}\n\n.client_info_item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.client_info_label {\n  opacity: 0.8;\n  font-size: 11px !important;\n  color: white !important;\n}\n\n.client_info_value {\n  font-weight: 600 !important;\n  font-size: 14px !important;\n  color: white !important;\n}\n\n/* Saldo Card */\n.saldo_card {\n  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);\n  padding: 15px 25px;\n  border-radius: 8px;\n  text-align: center;\n  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);\n  min-width: 250px;\n}\n\n.saldo_label {\n  color: white !important;\n  font-size: 12px !important;\n  margin-bottom: 5px !important;\n  opacity: 0.9;\n}\n\n.saldo_value {\n  color: white !important;\n  font-size: 28px !important;\n  font-weight: 700 !important;\n}\n\n/* Grupo de Impostos */\n.grupo_impostos {\n  background: white;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 25px;\n  margin-bottom: 30px;\n}\n\n.grupo_header {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 25px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #1e4a7a;\n}\n\n.grupo_icon {\n  font-size: 32px;\n  display: flex;\n  align-items: center;\n}\n\n.grupo_title {\n  flex: 1;\n}\n\n.grupo_name {\n  font-size: 22px !important;\n  font-weight: 700 !important;\n  color: #0d2847 !important;\n}\n\n.grupo_saldo {\n  text-align: right;\n}\n\n.grupo_saldo_label {\n  font-size: 12px !important;\n  color: #666 !important;\n  margin-bottom: 5px !important;\n}\n\n.grupo_saldo_value {\n  font-size: 24px !important;\n  font-weight: 700 !important;\n  color: #2e7d32 !important;\n}\n\n/* Tabela de Transações */\n.table_container {\n  margin-top: 20px;\n}\n\n.transactions_table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.transactions_table thead {\n  background: #f8f9fa;\n}\n\n.table_header_cell {\n  padding: 12px !important;\n  text-align: left !important;\n  font-weight: 600 !important;\n  color: #0d2847 !important;\n  border-bottom: 2px solid #e0e0e0 !important;\n  font-size: 14px !important;\n}\n\n.transactions_table th:nth-child(2),\n.transactions_table th:nth-child(3) {\n  text-align: right !important;\n  width: 180px;\n}\n\n.table_row {\n  border-bottom: 1px solid #f0f0f0 !important;\n}\n\n.table_row:hover {\n  background-color: #f9fbff !important;\n}\n\n.transaction_name {\n  font-weight: 500;\n  color: #333;\n  font-size: 13px;\n}\n\n.transaction_date {\n  font-size: 11px;\n  color: #666;\n  display: block;\n  margin-top: 2px;\n}\n\n.transaction_project {\n  font-size: 11px;\n  color: #1e4a7a;\n  display: block;\n  margin-top: 2px;\n}\n\n.value_credito {\n  color: #2e7d32;\n  font-weight: 600;\n  text-align: right;\n}\n\n.value_debito {\n  color: #c62828;\n  font-weight: 600;\n  text-align: right;\n}\n\n.value_empty {\n  color: #ddd;\n  text-align: right;\n}\n\n.table_footer {\n  background-color: #e3f2fd !important;\n  font-weight: 700 !important;\n}\n\n.table_footer_cell {\n  padding: 15px !important;\n  color: #0d2847 !important;\n  border-top: 2px solid #1e4a7a !important;\n}\n\n.table_footer_cell[align=\"right\"] {\n  white-space: nowrap;\n  min-width: 180px;\n}\n\n.total_credito {\n  color: #2e7d32;\n  font-size: 16px;\n  white-space: nowrap;\n  display: inline-block;\n}\n\n.total_debito {\n  color: #c62828;\n  font-size: 16px;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .container {\n    padding: 15px;\n    margin: 15px;\n  }\n\n  .client_header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .saldo_card {\n    width: 100%;\n  }\n\n  .client_info {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .header_actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .back_btn,\n  .btn_lancar_debito {\n    width: 100%;\n  }\n\n  .grupo_header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .grupo_saldo {\n    text-align: left;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__44eTj`,
	"header_actions": `styles_header_actions__6qx1Y`,
	"back_btn": `styles_back_btn__QvtNY`,
	"btn_lancar_debito": `styles_btn_lancar_debito__3O41f`,
	"breadcrumb": `styles_breadcrumb__zQzR+`,
	"breadcrumb_link": `styles_breadcrumb_link__Ctn+4`,
	"breadcrumb_separator": `styles_breadcrumb_separator__tKiel`,
	"breadcrumb_current": `styles_breadcrumb_current__xjs+S`,
	"client_header": `styles_client_header__EFrdj`,
	"client_header_left": `styles_client_header_left__nfIWv`,
	"client_name": `styles_client_name__JvK1G`,
	"client_info": `styles_client_info__dVMyf`,
	"client_info_item": `styles_client_info_item__pUrlr`,
	"client_info_label": `styles_client_info_label__oeJbK`,
	"client_info_value": `styles_client_info_value__EOsRZ`,
	"saldo_card": `styles_saldo_card__VAypf`,
	"saldo_label": `styles_saldo_label__RtVFZ`,
	"saldo_value": `styles_saldo_value__ZG4IK`,
	"grupo_impostos": `styles_grupo_impostos__hFq8K`,
	"grupo_header": `styles_grupo_header__TWt-l`,
	"grupo_icon": `styles_grupo_icon__iBOAe`,
	"grupo_title": `styles_grupo_title__lE1ax`,
	"grupo_name": `styles_grupo_name__8bb7c`,
	"grupo_saldo": `styles_grupo_saldo__lUiAJ`,
	"grupo_saldo_label": `styles_grupo_saldo_label__bR2Uv`,
	"grupo_saldo_value": `styles_grupo_saldo_value__raHDN`,
	"table_container": `styles_table_container__BDBw3`,
	"transactions_table": `styles_transactions_table__ux+EB`,
	"table_header_cell": `styles_table_header_cell__J8hv6`,
	"table_row": `styles_table_row__0aZDv`,
	"transaction_name": `styles_transaction_name__rOHPT`,
	"transaction_date": `styles_transaction_date__MUzMW`,
	"transaction_project": `styles_transaction_project__zjuyP`,
	"value_credito": `styles_value_credito__QZo95`,
	"value_debito": `styles_value_debito__eMsW6`,
	"value_empty": `styles_value_empty__Y3HAt`,
	"table_footer": `styles_table_footer__ZCp1r`,
	"table_footer_cell": `styles_table_footer_cell__Wt1Qa`,
	"total_credito": `styles_total_credito__e0Yaz`,
	"total_debito": `styles_total_debito__lTJVU`
};
export default ___CSS_LOADER_EXPORT___;
